import { render } from "./AppLoading.vue?vue&type=template&id=646fde52"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"

import "./AppLoading.vue?vue&type=style&index=0&id=646fde52&lang=sass"
script.render = render

export default script